

<template>
  <app>
    <page-header :showTelephone="true" :telephone="getReseller.telephone">
        <template v-slot:logo>
          <router-link to="/" class="logo-link">
              <svg viewBox="0 0 198 40" width="198" height="40" loading="lazy">
                  <title>Virgin Money homepage</title>                
                  <circle xmlns="http://www.w3.org/2000/svg" class="cls-1" cx="69.9375" cy="20.375" r="19"></circle>
                  <use :xlink:href="require(`./assets/theme/${getReseller.id}/images/rebrand_ui.svg`) + '#hero'"></use>                
              </svg>
          </router-link>
        </template>
    </page-header>
    <leadarticle />
    <main :class="mainContainerClass">
      <router-view name="main"/>
    </main>
    <page-footer>
      <template v-slot:main>
        <p v-if="showLegalText || showfcaText" v-html="getReseller.displayName + ' ' + getMasterInfo.underwriter"></p>
        <p v-if="showLegalText" v-html="getReseller.legalText"></p>
        <p v-if="showfcaText" v-html="getReseller.fcaText"></p>
          
        <p v-html="getReseller.footerText1"></p>
        <p v-html="getReseller.footerText2"></p>
      </template>
      <template v-slot:copyright>
        <p>{{getMasterInfo.copyright}}</p>
      </template>
    </page-footer> 
  </app>
</template> 

<script>

import App from "@/components/AppContainer.vue";
import backtoTop from "@/components/taurus-backtotop/components/BacktoTop.vue";
import pageHeader from "@/components/PageHeaderV2.vue";
import pageFooter from "@/components/PageFooterV2.vue";
import claimGuideTab from '@/components/ClaimGuideTab.vue';
import leadarticle from "./views/LeadArticle.vue";
import {mapGetters} from 'vuex';

export default {
  components: {
    App,
    backtoTop,
    pageHeader,
    pageFooter,
    claimGuideTab,
    leadarticle
  },
  data: () => ({
    window: {
      width: 0,
      height: 0
    }
  }),
  beforeCreate() {
    this.$store.commit("initialise");
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    //console.log('-r: ', this.getReseller)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    policyReseller(val) { //watches for changes and updates groupResellerInfo
      this.$store.dispatch('reseller/findGroupReseller', val)
    }
  },
  computed: {
    ...mapGetters({      
      getMasterInfo: 'reseller/getMasterInfo' ,
      getReseller: 'reseller/getResellerInfo',
      getGroupResellerInfo: 'reseller/getGroupReseller',
      policyReseller: 'reseller/resellerId' //returns reseller id     
    }),
    showLegalText() {
      if (this.getReseller.legalText)
        return true
      else
        return false
      //return this.getReseller.legalText !== '' && this.getReseller.legalText !== null
    },
    showfcaText() {
      if (this.getReseller.fcaText)
        return true
      else
        return false
      //return this.getReseller.fcaText !== '' && this.getReseller.fcaText !== null
    },
    showStandardLogo() {
      return this.getGroupResellerInfo === '' 
        || Object.keys(this.getGroupResellerInfo).length === 0 
        && this.getGroupResellerInfo.constructor === Object;
    },
    showInAssociationLogo() {
      return process.env.VUE_APP_RESELLER_ID == 1001;
    },
    isStandalone() {
      return process.env.VUE_APP_FORM_TYPE == 'standalone';
    },
    isTiga() {
      return process.env.VUE_APP_FORM_TYPE == 'tiga';
    },
    isTif() {
      return process.env.VUE_APP_RESELLER_ID == 1001;
    },
    hasNoGroup() {
      return this.getGroupResellerInfo === '' 
        || Object.keys(this.getGroupResellerInfo).length === 0 
        && this.getGroupResellerInfo.constructor === Object;
    },
    leadImageExt() {
      if (this.getReseller.leadImageExt)
          return this.getReseller.leadImageExt
      else
        return `jpg`
    },
    leadImage () {
      if (this.getReseller.leadImage)
          return this.getReseller.leadImage
      else
          return 'gadgets'
    },
    mainContainerClass() {
      if (this.$route.name=='home') {
        return 'main-container main-container-home-background'
      } else {
        return 'main-container'
      }
      
    }
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>
